import { toast } from 'wc-toast'

export const notify = {
	success: (msg) => toast.success(msg),
	error: (msg) => toast.error(msg),
	info: (msg) => toast(msg),
}
